import script from "./fit-video-player.vue?vue&type=script&setup=true&lang=js"
export * from "./fit-video-player.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__